<!-- 关于我们 -->
<template>

    <div class="joinbox">
        <div class="banxin">
             <div class="logobtns">
             <h1 class="logo"></h1> 
             <!-- <button class="regbtn"  @click="goRecharge()">Recharge</button>  -->
            </div>
             <h1>Community Rules for Mango Live Users</h1>
             <p style="font-weight:bold;">To build up a positive broadcasting experience, MANGO LIVE sets the Community Rules for Mango User Community based on the general opinions collected from all users. Mango Live hopes all the users follow the rules as additional guidance of the Regulations Against Violations in the Broadcasting Room.</p>
             <p>1. It’s prohibited to advocate or incite radical or illegal speech or actions, such as fighting, threatening to fight, disturbing the public order, or damaging public facilities, etc. during broadcastings and on the bullet comments. </p>
             <p>2. It‘s prohibited to scout, insult, or use radical words leading to bad results on the live session and bullet comments.</p>
             <p>3. During broadcastings, it’s prohibited to advocate life values of irrational consumption such as flaunting wealth and also prohibited to advocate corrupted lifestyles such as smoking and alcohol drinking.</p>
             <p>4. It’s prohibited to infringement privacy rights including but not limited to 
               <br>&nbsp;&nbsp;&nbsp;  a. Expose others’ private information to the public without permission; 
               <br>&nbsp;&nbsp;&nbsp; b. Stalk or monitor others; 
               <br>&nbsp;&nbsp;&nbsp;  c. Investigate or spy others’ social relationships and reveal to the public. </p>
             <p>5. It’s prohibited to instigate fans or streams, to incite battles or to stir up conflicts and flame wars in many ways including but not limited to making use of live broadcasting, bullet comments and private messages. It’s prohibited to disturb the public order on the platform to make trouble for the operation. Broadcasters shall be responsible for the behaviors of their own fans.  </p>
             <p>6. It’s prohibited to trade, exchange or pledge any sources of the platform, and to make use of bugs to generate illegal benefits including but not limited to account, broadcasting room, coins and diamonds, virtual gifts and tickets. </p>
     <p style="font-weight:bold;">These common rules are applied to all broadcasters and users, and all behaviors during live sessions and on the platform. MANGO LIVE will appreciate it very much if you could consider the rules to create a good environment for all users. Please contact us at http://www.mangolive.in/ if you have any questions.</p>
        </div>
         <!-- <Footer></Footer> -->
    </div>  
</template>
<script>
export default {

    data(){
        return{
          isuser:true
        }
    },
     created(){

    },
    methods:{

    },
}
</script>
<style lang="less" scoped>

@media screen and (min-width: 900px) {
  .joinbox{
       background:#fff;
       font-size: .09rem;line-height:0.17rem
  }


    .logobtns{
      width: 100%; height: .42rem; display: flex; 
       box-sizing: border-box;
      justify-content: space-between; align-items: center;
     .logo{
         width:1.04rem; height: .2rem;
        background:  url('../../assets/images/liveimg/LOGO_phone@2x.png');
        background-size: 100% 100%;
     } 
  }
  h1{
    font-size:0.13rem; margin: .1rem 0 .08rem 0;
  }
     p{ margin-top: .14rem}
}
@media screen and (max-width:899px){
  .joinbox{
       background:#fff;
       font-size: .3rem;line-height:0.45rem
  }
  .banxin{
    width: 80%;
  }


    .logobtns{
      width: 100%; height: .8rem; display: flex; 
       box-sizing: border-box;
      justify-content: space-between; align-items: center;
     .logo{
         width:3.46rem; height: .6rem;
        background:  url('../../assets/images/liveimg/LOGO_phone@2x.png');
        background-size: 100% 100%;
     } 
  }
    h1{
    font-size:0.4rem; margin: .5rem 0 .2rem 0;
  }
   p{ margin-top: .4rem}
}

</style>


// WEBPACK FOOTER //
// src/page/webpage/community.vue